import firebase from 'firebase/app'
import 'firebase/firestore'
import firebaseui from 'firebaseui'
import { firebaseConfig } from './config'

export const firebaseApp = firebase.initializeApp(firebaseConfig)
export const firebaseDb = firebaseApp.firestore()

export const firebaseUi = new firebaseui.auth.AuthUI(firebaseApp.auth())
export const firebaseUiConfig = {
  signInFlow: 'popup',
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID
  ],
  callbacks: {
    signInSuccessWithAuthResult: () => false,
  }
}

export const ServerTimestamp = firebase.firestore.FieldValue.serverTimestamp()



// WEBPACK FOOTER //
// ./src/firebase/index.js